import React from "react";
import { Controller } from "react-hook-form";
import styles from "./styles.module.scss";
import getValidationRules from "src/validations/ValidationRules";
import { CustomInput, UIText } from "src/components/uIKit";
import ErrorMessage from "src/components/errorMessage";
import { useAppSelector } from "src/hooks/useRedux";
import { INPUT_LENGTH } from "src/utils/enums";
import { useOutletContext } from "react-router-dom";
import ScreenReaderText from "src/components/accessibilityKit/screenReaderText/ScreenReaderText";

interface OtpProps {
  phone: string;
}

const Otp: React.FC = () => {
  const { phone } = useOutletContext<OtpProps>();
  const { strings, otpErrorMessage } = useAppSelector((state) => state.app);
  const validationRules = getValidationRules(strings);

  return (
    <div className={styles.infoPart} tabIndex={0} role="alert">
      <ScreenReaderText text={strings.acc_t_otp_subTitle} announnceDelay={2100}/>

      <UIText
        text={strings.t_otp_subTitle}
        size={22}
        weight={600}
        style={styles.cardTitle}
      />
      <br />

      <Controller
        name="otp"
        rules={validationRules.otp}
        render={({ field, fieldState: { error } }) => (
          <>
            <UIText
              text={strings.t_otp_placeholder}
              size={18}
              weight={400}
              style={styles.cardSubTitle}
            />
            <br />
            <br />
            <div className={styles.pRelative}>
              <CustomInput
                inputType="otp"
                type="text"
                {...field}
                maxLength={INPUT_LENGTH.OTP}
                minLength={INPUT_LENGTH.OTP}
                customStyle={styles.inputContainerCustomStyle}
              />
              <ErrorMessage style={styles.error} message={error?.message} />
            </div>
          </>
        )}
      />

      <br />
      <br />

      <div className={styles.otpPlaceHolder}>
        <UIText
          text={strings.t_otp_placeholder_info}
          size={18}
          weight={400}
          style={styles.codeSendTo}
        />
        <UIText
          text={phone?.slice(-4)}
          size={18}
          weight={400}
          style={styles.codeSendTo}
        />
      </div>
    </div>
  );
};

export default Otp;
